import React from 'react';
import {
  nsResources,
  crsResources,
  tmResources
} from '../../util/GlobalConstant';

import TMInvestigationDetail from '../tm/investigationDetail';
import TMInvestigation from '../tm/investigation';
import TMDashboard from '../tm/dashboard';

import NSInvestigationDetail from '../ns/investigationDetail';
import NSInvestigation from '../ns/investigation';
import NSDashboard from '../ns/dashboard';

import CRSListing from '../crs/crsListingPage';
import CRSRiskDetail from '../crs/crsRiskDetail';

import { ROUTE_AMLS_SMART_SCREENING } from '../constants/globalConstants';

export const NAMESPACE_SMART_SCREENING = 'SMART-SCREENING';
export const NAMESPACE_TM = 'TM';
export const NAMESPACE_CRS = 'CRS';
export const NAMESPACE_CM = 'CM';
export const NAMESPACE_NS = 'NS';
export const NAMESPACE_SANDBOX = 'SANDBOX';
export const NAMESPACE_AMLS = 'AMLS';
//TODO: Need to check if this is required for TRM
export const NAMESPACE_TRM = 'TRM';

export const getDefaultModule = (uniqueModules) => {
  let defaultModule;
  let hideModuleDropDown = false;
  if (uniqueModules.length === 1) {
    hideModuleDropDown = true;
    defaultModule = uniqueModules[0].module;
  } else {
    let moduleCombinationScore = 0;
    uniqueModules.forEach((moduleObject) => {
      switch (moduleObject.module) {
        case NAMESPACE_TM:
          moduleCombinationScore += 1;
          break;
        case NAMESPACE_SMART_SCREENING:
          moduleCombinationScore += 2;
          break;
        case NAMESPACE_CRS:
          moduleCombinationScore += 3;
          break;
        default:
          break;
      }
    });

    if (moduleCombinationScore === 3) {
      defaultModule = NAMESPACE_TM.toLowerCase();
    }
    if (moduleCombinationScore === 4) {
      defaultModule = NAMESPACE_TM.toLowerCase();
    }
    if (moduleCombinationScore === 5) {
      defaultModule = NAMESPACE_SMART_SCREENING.toLowerCase();
    }
    if (moduleCombinationScore === 6) {
      defaultModule = NAMESPACE_TM.toLowerCase();
    }
  }
  return {
    defaultModule,
    hideModuleDropDown
  };
};

export const getActiveSidebarByPath = (path) => {
  if (path.indexOf('investigation') >= 0) return 2;
  return 1;
};
export const getCurrentAppByPath = (path) => {
  if (path.startsWith(`/app/${NAMESPACE_SMART_SCREENING.toLowerCase()}`))
    return NAMESPACE_SMART_SCREENING.toLowerCase();
  if (path.startsWith(`/app/${NAMESPACE_TM.toLowerCase()}`))
    return NAMESPACE_TM.toLowerCase();
  if (path.startsWith(`/app/${NAMESPACE_CRS.toLowerCase()}`))
    return NAMESPACE_CRS.toLowerCase();
  if (path.startsWith(`/app/${NAMESPACE_CM.toLowerCase()}`))
    return NAMESPACE_CM.toLowerCase();
  if (path.startsWith(`/app/${NAMESPACE_NS.toLowerCase()}`))
    return NAMESPACE_NS.toLowerCase();
  if (path.startsWith(`/app/${NAMESPACE_SANDBOX.toLowerCase()}`))
    return NAMESPACE_SANDBOX.toLowerCase();
  //TODO: Need to check if this is required for TRM
  if (path.startsWith(`/app/${NAMESPACE_TRM.toLowerCase()}`))
    return NAMESPACE_TRM.toLowerCase();
  return '404';
};

const params = new URLSearchParams(location.search);

export const AMLS_MODULES = {
  NS_PAGES: {
    NS_ALERTS_LIST: {
      code: nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST,
      url: `${ROUTE_AMLS_SMART_SCREENING}/investigation`,
      routePath: `${ROUTE_AMLS_SMART_SCREENING}/investigation`,
      componentName: NSInvestigation,
      text: 'INVESTIGATION_LIST',
      module: NAMESPACE_SMART_SCREENING,
      priority: 1,
      icon: 'fa fa-eye fa-2x',
      homeURL: `${ROUTE_AMLS_SMART_SCREENING}/investigation`
    },
    NS_RISK_VIEW_PAGE: {
      code: nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW,
      url: `${ROUTE_AMLS_SMART_SCREENING}/dashboard`,
      routePath: `${ROUTE_AMLS_SMART_SCREENING}/dashboard`,
      componentName: NSDashboard,
      text: 'RISK VIEW',
      module: NAMESPACE_SMART_SCREENING,
      priority: 0,
      icon: 'fa fa-home fa-2x',
      homeURL: `${ROUTE_AMLS_SMART_SCREENING}/investigation`
    }
  },
  TM_PAGES: {
    TM_ALERT_LIST_PAGE: {
      code: tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS,
      url: '/app/tm/investigation',
      routePath: '/app/tm/investigation',
      componentName: TMInvestigation,
      text: 'INVESTIGATION_LIST',
      module: NAMESPACE_TM,
      priority: 3,
      icon: 'fa fa-eye fa-2x',
      homeURL: '/app/tm/investigation'
    },
    TM_ALERT_LIST_ANOMALIES: {
      code: tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES,
      url: '/app/tm/investigation',
      routePath: '/app/tm/investigation',
      componentName: TMInvestigation,
      text: 'INVESTIGATION_LIST',
      module: NAMESPACE_TM,
      priority: 2,
      icon: 'fa fa-eye fa-2x',
      homeURL: '/app/tm/investigation'
    },
    TM_INVESTIGATION_PAGE: {
      code: tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE,
      url: '/app/tm/investigation',
      routePath: '/app/tm/investigation/:alertId',
      componentName: TMInvestigationDetail,
      text: 'INVESTIGATION_DETAIL',
      hideInSidebar: true,
      module: NAMESPACE_TM,
      priority: 1,
      icon: 'fa fa-eye fa-2x',
      homeURL: '/app/tm/investigation'
    },
    TM_DASHBOARD_PAGE: {
      code: tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD,
      url: '/app/tm/dashboard',
      routePath: '/app/tm/dashboard',
      componentName: TMDashboard,
      text: 'RISK_VIEW',
      module: NAMESPACE_TM,
      priority: 0,
      icon: 'fa fa-home fa-2x',
      homeURL: '/app/tm/investigation'
    }
  },
  CRS_PAGES: {
    CRS_LIST_VIEW_PAGE: {
      code: crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST,
      url: '/app/crs/customers',
      routePath: '/app/crs/customers',
      componentName: CRSListing,
      module: NAMESPACE_CRS,
      priority: 1,
      text: 'RISK_LIST',
      icon: 'fa fa-eye fa-2x',
      homeURL: '/app/crs/dashboard'
    },
    CRS_DETAIL_VIEW_PAGE: {
      code: crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL,
      url: '/app/crs/details',
      routePath: '/app/crs/details/:customer_id',
      componentName: CRSRiskDetail,
      text: 'INVESTIGATION_DETAIL',
      module: NAMESPACE_CRS,
      priority: 1,
      hideInSidebar: true,
      icon: 'fa fa-eye fa-2x',
      homeURL: '/app/crs/dashboard'
    }
  }
};

export const getAppName = (module) => {
  switch (module?.moduleCode) {
    case 'TM-SAM':
    case 'TM-IAD':
    case 'Fraud Detection':
    case 'Fraud Prevention':
    case 'Detection':
      return 'tm';
    case 'NS-SAM':
    case 'NS-IAD':
    case 'TS-SAM':
    case 'TS-IAD':
    case 'PS':
    case 'RS':
    case 'PS-RS':
      return 'smart-screening';
    case 'CRS':
      return 'crs';
    case 'CM':
      return 'cm';
    case 'AFC':
      return 'afc';
    case 'sandbox':
      return 'sandbox';
    default:
      return '';
  }
};
